import React, { useState } from 'react';
import { TextField, Button, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { createProjet, updateProjet } from '../../api/projetApi';

const CreerProjet = ({ projet }) => {
  const [formData, setFormData] = useState(
    projet || {
      nom: '',
      description: '',
      date_debut: '2025-12-01',
      date_fin: '2025-12-31',
      budget: 1000.00,
      statut: 'en_cours',
    }
  );

  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const projetData = {
      ...formData,
      budget: Number(formData.budget),
    };
    console.log("Données envoyées :", projetData);
    try {
      if (projet) {
        await updateProjet(projet.id, projetData);
      } else {
        await createProjet(projetData);
      }
      navigate('/projets');
    } catch (error) {
      console.error("Erreur :", error.response?.data);
      alert(`Erreur : ${error.response?.data?.error?.join(', ') || error.message}`);
    }
  };

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
      <TextField
        label="Nom du projet"
        name="nom"
        value={formData.nom}
        onChange={handleChange}
        fullWidth
        margin="normal"
        required
      />
      <TextField
        label="Description"
        name="description"
        value={formData.description}
        onChange={handleChange}
        fullWidth
        margin="normal"
        multiline
        rows={4}
      />
      <TextField
        label="Date de début"
        name="date_debut"
        type="date"
        value={formData.date_debut}
        onChange={handleChange}
        fullWidth
        margin="normal"
        InputLabelProps={{ shrink: true }}
      />
      <TextField
        label="Date de fin"
        name="date_fin"
        type="date"
        value={formData.date_fin}
        onChange={handleChange}
        fullWidth
        margin="normal"
        InputLabelProps={{ shrink: true }}
      />
      <TextField
        label="Budget"
        name="budget"
        type="number"
        value={formData.budget}
        onChange={handleChange}
        fullWidth
        margin="normal"
      />
      <TextField
        label="Statut"
        name="statut"
        value={formData.statut}
        onChange={handleChange}
        fullWidth
        margin="normal"
      />
      <Button type="submit" variant="contained" color="primary" sx={{ mt: 2 }}>
        Enregistrer
      </Button>
    </Box>
  );
};

export default CreerProjet;
